interface Props {
  userName: string;
}

export function TypingIndicator({ userName }: Props) {
  return (
    <div className="typing-indicator">
      <span className="typing-indicator-text">{userName} is typing</span>
      <span className="typing-indicator-dots">
        <span className="typing-dot" />
        <span className="typing-dot" />
        <span className="typing-dot" />
      </span>
    </div>
  );
}
